import type { AnalyticsData } from '@mwl/core-lib';
import { formatUrlToStr } from '@mwl/core-lib';

import type { GetSportToolbarAnalytics } from './SportToolbar.types';

// NOTE: Если будем переносить в core, то лучше в packages/core/src/analytics/sport/sportToolbar
export const getSportToolbarAnalytics: GetSportToolbarAnalytics = ({ href, count, position }) => {
  const analyticsData: AnalyticsData = {
    href: formatUrlToStr(href),
    count,
    position: position + 1,
  };

  return {
    sportToolbarAnalytics: {
      select: {
        eventName: 'sportTopFilter_sportCategory_select',
        data: analyticsData,
      },
      unselect: {
        eventName: 'sportTopFilter_sportCategory_unselect',
        data: analyticsData,
      },
    },
  };
};
